module.exports = "/public/images/a965336afd57b5bf3d3e92242a3aad59.svg";